import React from "react";
import "./Common_heading.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesRight } from "@fortawesome/free-solid-svg-icons";

function Common_heading({ heading, subHeading, headingTag = "h2",subHeadingTag = "p" }) {
  const HeadingTag = headingTag;
  const SubHeadingTag = subHeadingTag;

  return (
    <>
      <section className="Common_heading">
        <HeadingTag className="head_text mb-3">
          <FontAwesomeIcon icon={faAnglesRight} className="me-3" /> {heading}
        </HeadingTag>

        <SubHeadingTag className="text">{subHeading}</SubHeadingTag>
      </section>
    </>
  );
}

export default Common_heading;
